var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInvestormultiple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_386_4537)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_386_4537",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8105 0.648438H0V16.459H15.8105V0.648438Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_386_4537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8464 16.459H2.9648C2.05701 16.459 1.31787 15.7198 1.31787 14.8121V2.29536C1.31787 1.38758 2.05701 0.648438 2.9648 0.648438H12.8464C13.7542 0.648438 14.4933 1.38758 14.4933 2.29536V14.8121C14.4933 15.7198 13.7542 16.459 12.8464 16.459ZM2.9648 1.30721C2.41999 1.30721 1.97664 1.75057 1.97664 2.29536V14.8121C1.97664 15.3568 2.41999 15.8002 2.9648 15.8002H12.8464C13.3911 15.8002 13.8345 15.3568 13.8345 14.8121V2.29536C13.8345 1.75057 13.3911 1.30721 12.8464 1.30721H2.9648Z",
    fill: "#12263F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5286 5.91862H4.2821C3.7373 5.91862 3.29395 5.47526 3.29395 4.93046V3.61291C3.29395 3.06811 3.7373 2.62476 4.2821 2.62476H11.5286C12.0734 2.62476 12.5167 3.06811 12.5167 3.61291V4.93046C12.5167 5.47526 12.0734 5.91862 11.5286 5.91862ZM4.2821 3.28353C4.10028 3.28353 3.95271 3.43109 3.95271 3.61291V4.93046C3.95271 5.11228 4.10028 5.25984 4.2821 5.25984H11.5286C11.7104 5.25984 11.858 5.11228 11.858 4.93046V3.61291C11.858 3.43109 11.7104 3.28353 11.5286 3.28353H4.2821Z",
    fill: "#12263F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27031 9.87118C5.08849 9.87118 4.94092 9.72359 4.94092 9.54177V7.56547C4.94092 7.38365 5.08849 7.23608 5.27031 7.23608C5.45213 7.23608 5.5997 7.38365 5.5997 7.56547V9.54177C5.5997 9.72359 5.45213 9.87118 5.27031 9.87118Z",
    fill: "#12263F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25833 8.88303H4.28203C4.1002 8.88303 3.95264 8.73544 3.95264 8.55362C3.95264 8.37181 4.1002 8.22424 4.28203 8.22424H6.25833C6.44015 8.22424 6.58772 8.37181 6.58772 8.55362C6.58772 8.73544 6.44015 8.88303 6.25833 8.88303Z",
    fill: "#12263F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5289 8.88303H9.55256C9.37074 8.88303 9.22314 8.73544 9.22314 8.55362C9.22314 8.37181 9.37074 8.22424 9.55256 8.22424H11.5289C11.7107 8.22424 11.8583 8.37181 11.8583 8.55362C11.8583 8.73544 11.7107 8.88303 11.5289 8.88303Z",
    fill: "#12263F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5289 11.8475H9.55256C9.37074 11.8475 9.22314 11.6999 9.22314 11.5181C9.22314 11.3363 9.37074 11.1888 9.55256 11.1888H11.5289C11.7107 11.1888 11.8583 11.3363 11.8583 11.5181C11.8583 11.6999 11.7107 11.8475 11.5289 11.8475Z",
    fill: "#12263F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5289 13.8238H9.55256C9.37074 13.8238 9.22314 13.6763 9.22314 13.4944C9.22314 13.3126 9.37074 13.1651 9.55256 13.1651H11.5289C11.7107 13.1651 11.8583 13.3126 11.8583 13.4944C11.8583 13.6763 11.7107 13.8238 11.5289 13.8238Z",
    fill: "#12263F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.28219 13.8239C4.19787 13.8239 4.11354 13.7916 4.04898 13.7277C3.92052 13.5992 3.92052 13.3905 4.04898 13.262L6.0253 11.2857C6.15376 11.1572 6.36259 11.1572 6.49105 11.2857C6.61951 11.4141 6.61951 11.6229 6.49105 11.7514L4.51474 13.7277C4.45084 13.7916 4.36651 13.8239 4.28219 13.8239Z",
    fill: "#12263F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2585 13.8239C6.17419 13.8239 6.08986 13.7916 6.0253 13.7277L4.04898 11.7514C3.92052 11.6229 3.92052 11.4141 4.04898 11.2857C4.17744 11.1572 4.38628 11.1572 4.51474 11.2857L6.49105 13.262C6.61951 13.3905 6.61951 13.5992 6.49105 13.7277C6.42715 13.7916 6.34283 13.8239 6.2585 13.8239Z",
    fill: "#12263F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_386_4537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.8105,
    height: 15.8105,
    fill: "white",
    transform: "translate(0 0.648438)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInvestormultiple);
export default __webpack_public_path__ + "static/media/icon_investormultiple.de6f155b13497f510bd1ff675aaf7107.svg";
export { ForwardRef as ReactComponent };